{% block ecocode_trustpilot_connect %}
    <sw-card>
        <ecocode-trustpilot-invitation-recover ref="invitation" v-bind="{salesChannel}"></ecocode-trustpilot-invitation-recover>
        <sw-button
            @click="sendInvitation"
            variant="primary"
            size="large">
            Send
        </sw-button>
    </sw-card>
{% endblock %}
